<template>
    <select multiple="multiple">
        <slot></slot>
    </select>
</template>
<script>


export default {
    props: {
        value: {
            default: []
        },
        options: {
            type: Array,
            required : true
        },
        placeholder: {
            type: String,
            default: ""
        },
    },

    mounted: function () {
        var vm = this
        $(this.$el)
            .select2({
                data: this.options,
                placeholder: vm.placeholder,
                minimumResultsForSearch: Infinity,
                minimumInputLength: 0,
            })
            .on('change', function () {
               vm.updateSelection($(this).val())
            })
            .val(vm.value)
            .trigger('change');
    },
    data() {
        return {
            valuesData : []
        }
    },
    watch: {
        value: function (value) {
            this.informSelection(value);
        },
        valuesData: function (value) {

        },
        options: function (options) {
            $(this.$el).empty().select2({ data: options })
        }
    },
    destroyed: function () {
        $(this.$el).off().select2('destroy')
    },
    methods : {
        updateSelection : function(v) {
            this.valuesData = v;
            this.informUpdate();
        },
        informSelection : function(v) {
            if ( $(this.$el) !== v){
                $(this.$el)
                    .val(v)
                    .trigger('change');
            }
        },
        informUpdate : function(){
            if (this.valuesData.length !== this.value.length)
                this.$emit('input', this.valuesData)
        },


    }
}
</script>